import type { CopilotThemeOptions } from "owa-copilot-themes-types";
import { createStore } from "owa-satcheljs";
import { ThemeConstants } from "owa-theme-shared";
import type { CopilotThemeOptionState } from "./schema/CopilotThemeOptionState";
import getThemeOptionsFromPrimeSettings from "../utils/getThemeOptionsFromPrimeSettings";

let isInitialized = false;

const defaultStore: CopilotThemeOptionState = {
    options: {
        themeId: ThemeConstants.COPILOT_CUSTOM_THEME_ID,
        isSelected: false,
        type: "City",
        location: "SeattleWA",
        style: "Realistic",
        refreshRate: "None",
        lastRefreshDate: "",
        lightThemeResources: {} as any,
        darkThemeResources: {} as any,
    },
    timestamp: "",
    isAccentColorUpdate: false,
};

const copilotThemeStore = createStore<CopilotThemeOptionState>("copilotThemeStore", defaultStore);

export function getStore(): CopilotThemeOptionState {
    const store = copilotThemeStore();
    
    if (!isInitialized) {
        isInitialized = true;
        const themeOptionsSetting = getThemeOptionsFromPrimeSettings();
        const copilotThemeOptions: CopilotThemeOptions | undefined = themeOptionsSetting?.value
            ? JSON.parse(themeOptionsSetting.value)
            : undefined;
        
        if (copilotThemeOptions) {
            store.options = copilotThemeOptions;
        }
        if (themeOptionsSetting?.Timestamp) {
            store.timestamp = themeOptionsSetting.Timestamp;
        }
    }
    
    return store;
}
